var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 112,
    viewBox: "0 0 136 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 44C137.669 90.9168 99.4457 112 69.3092 112C39.1727 112 0 86.6592 0 59.6696C0 32.6801 7.19355 15.8734 37.5085 5.46611C67.8235 -4.94119 130.331 -2.91677 134 44Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9812 28.758C66.8312 27.3027 69.1692 27.3027 71.0192 28.758L95.32 47.8754C95.9501 48.3711 96.3335 49.2462 96.3335 50.1884C96.3335 51.2121 95.8814 52.1492 95.1637 52.613L68.0002 70.1665L40.8367 52.613C40.119 52.1492 39.6669 51.2121 39.6669 50.1884C39.6669 49.2462 40.0503 48.3711 40.6804 47.8754L64.9812 28.758Z",
    fill: "#8E8CEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1669 30.8493C48.1669 29.0915 49.209 27.6665 50.4944 27.6665H85.506C86.7914 27.6665 87.8335 29.0915 87.8335 30.8493V61.3171C87.8335 63.0749 86.7914 64.4998 85.506 64.4998H50.4944C49.209 64.4998 48.1669 63.0749 48.1669 61.3171V30.8493Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.8335,
    y: 38.9998,
    width: 28.3333,
    height: 2.83333,
    rx: 1.41667,
    fill: "#E6E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8335,
    y: 44.6665,
    width: 28.3333,
    height: 2.83333,
    rx: 1.41667,
    fill: "#E6E5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8335,
    y: 50.3333,
    width: 28.3333,
    height: 2.83333,
    rx: 1.41667,
    fill: "#E6E5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8335,
    y: 33.3333,
    width: 11.3333,
    height: 2.83333,
    rx: 1.41667,
    fill: "#8E8CEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6669 50.4828C39.6669 48.282 41.8864 46.8409 43.7928 47.8038L66.7443 59.3974C67.5371 59.7978 68.4632 59.7978 69.256 59.3974L92.2076 47.8038C94.1139 46.8409 96.3334 48.282 96.3334 50.4828V78.5204C96.3334 80.1659 95.0485 81.4998 93.4634 81.4998H42.5369C40.9518 81.4998 39.6669 80.1659 39.6669 78.5204V50.4828Z",
    fill: "url(#paint0_linear_41896_16542)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_41896_16542",
    x1: 130.334,
    y1: 38.9998,
    x2: 82.3263,
    y2: 126.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485195,
    stopColor: "#D3D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485295,
    stopColor: "#B1B0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1B0F5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email-sent.7448fe0406cf638615d11f47ecf2898e.svg";
export { ForwardRef as ReactComponent };